<footer id="footer" class="footer md-pb-70">
  <div class="footer-wrap">
      <div class="footer-body">
          <div class="container">
              <div class="row">
                  <div class="col-xl-3 col-md-6 col-12">
                      <div class="footer-infor">
                          <div class="footer-logo">
                              <a  style="width: 80px; height: 0px; margin-bottom: 10px;">
                                  <img src="assets/images/logo.png" alt="">
                              </a>
                          </div>
                          <ul>
                              <li>
                                  <p>une marque 100% tunisienne. Fondée en 2020, notre entreprise à taille humaine se démarque par son élégance et son originalité avec des produits conçus au sein de nos ateliers.
</p>
                              </li>
                              <li>

                              </li>
                              <li>

                              </li>
                          </ul>
                          <!-- <a href="contact-1.html" class="tf-btn btn-line">Get direction<i
                                  class="icon icon-arrow1-top-left"></i></a> -->
                          <ul class="tf-social-icon d-flex gap-10">
                              <li><a href="https://www.facebook.com/Adora.Store2" target="_blank" class="box-icon w_34 round social-facebook social-line"><i
                                          class="icon fs-14 icon-fb"></i></a></li>

                              <li><a href="https://www.instagram.com/adora_store_tn?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" class="box-icon w_34 round social-instagram social-line"><i
                                          class="icon fs-14 icon-instagram"></i></a></li>

                          </ul>
                      </div>
                  </div>
                  <div class="col-xl-3 col-md-6 col-12 footer-col-block">
                      <div class="footer-heading footer-heading-desktop">
                          <h6>Aide</h6>
                      </div>
                      <div class="footer-heading footer-heading-moblie">
                          <h6>Aide</h6>
                      </div>
                      <ul class="footer-menu-list tf-collapse-content">

                          <li>
                              <a href="delivery-return.html" class="footer-menu_item"> Retours & Échanges
                              </a>
                          </li>
                          <li>
                              <a href="shipping-delivery.html" class="footer-menu_item">Livraison</a>
                          </li>
                          <li>
                              <a href="terms-conditions.html" class="footer-menu_item">Conditions générales</a>
                          </li>


                          <li>
                              <a href="/wishlist" class="footer-menu_item">Ma liste favoris</a>
                          </li>
                      </ul>
                  </div>
                  <div class="col-xl-3 col-md-6 col-12 footer-col-block">
                      <div class="footer-heading footer-heading-desktop">
                          <h6>À propos</h6>
                      </div>
                      <div class="footer-heading footer-heading-moblie">
                          <h6>À propos</h6>
                      </div>
                      <ul class="footer-menu-list tf-collapse-content">
                          <li>
                              <a href="/contact" class="footer-menu_item">Notre histoire</a>
                          </li>
                          <li>
                              <a href="our-store.html" class="footer-menu_item">Boutique</a>
                          </li>
                          <li>
                              <a href="/contact" class="footer-menu_item">Contact</a>
                          </li>
                          <li>
                              <a href="login.html" class="footer-menu_item">Mon Compte</a>
                          </li>
                      </ul>
                  </div>
                  <div class="col-xl-3 col-md-6 col-12">
                      <div class="footer-infor">
                          <div class="footer-heading footer-heading-desktop">
                              <h6>Informations</h6>
                          </div>
                          <div class="footer-heading footer-heading-moblie">
                              <h6>Informations</h6>
                          </div>
                          <div class="tf-collapse-content">
                               <ul>
                                        <li>
                                            <p>Email: <a href="mailto:adorastoretn@gmail.com">adorastoretn@gmail.com</a></p>
                                        </li>
                                        <li>
                                            <p>Telephone: <a href="tel:+21658955712" >+216 58955712</a></p>
                                        </li>
                                         <li>
  <p>Facebook:
    <a href="https://www.facebook.com/Adora.Store2" target="_blank">Adora.Store2</a>
  </p>
</li>
<li>
  <p>Instagram:
    <a href="https://www.instagram.com/adora_store_tn?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank">@adora_store_tn</a>
  </p>
</li>

                                    </ul>

                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <div class="footer-bottom">
          <div class="container">
              <div class="row">
                  <div class="col-12">
                      <div
                          class="footer-bottom-wrap d-flex gap-20 flex-wrap justify-content-between align-items-center">
                          <div class="footer-menu_item">© 2025 Ecomus Store.  Tous droits réservés | Créé avec <i style="color:black" class="fas fa-heart" aria-hidden="true"></i> par <a href="http://premiumnetagency.com/" target="_blank" style="color:black">PreNetAgency</a></div>

                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</footer>
